<div class="title">{{ nameKey | translate }}</div>

<automata-automation-replacement-chips
  [label]="'CRM_FIELDS_DIALOG.CUSTOM_OBJECT_TYPE'"
  [dataService]="crmCustomObjectTypeSelectorService"
  [formControl]="customObjectTypeFormControl"
  [isRequired]="true"
  [multiple]="false"
  [supportDataPassing]="false"
  (finishedInitialLoading)="finishedLoadingSelector()"
></automata-automation-replacement-chips>

@if (hasObjectTypeSelected()) {
  @if (automationContext === context.AUTOMATION_CONTEXT_PARTNER) {
    <glxy-form-field>
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TRIGGERS.MANUAL_ACCOUNT_TRIGGER.WHO_CAN_RUN' | translate }}
      </glxy-label>
      <mat-select [(value)]="selectedOption">
        @for (option of options; track option.value) {
          <mat-option [value]="option.value">
            {{ option.label | translate }}
          </mat-option>
        }
      </mat-select>
    </glxy-form-field>

    @if (selectedOption === specificUsers) {
      <automata-automation-replacement-chips
        label="AUTOMATIONS.EDITOR.TRIGGERS.MANUAL_ACCOUNT_TRIGGER.SPECIFIC_USERS_DESCRIPTION"
        [dataService]="userSelectorService"
        [formControl]="usersFormControl"
        [isRequired]="false"
        [supportDataPassing]="false"
      ></automata-automation-replacement-chips>
    }
  } @else {
    <div>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.MANUAL_ACCOUNT_TRIGGER.SMB_INSTRUCTIONS' | translate }}</div>
  }
}
